var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmails(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 8.55l14.2 10.3c2 1.6 3.5.1 3.5.1L32 8.55v19.2H0zm0-4.3h31.9v1.9l-15.5 11.2s-.5.4-.9.1L0 5.95z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default ForwardRef;